<template>
    <td>
    <k-dialog v-if="warrning.opozorilo" :title="'Potrdi izbiro!'" @close="closeDialogConfirm">
        <p :style="{ margin: '25px', textAlign: 'center' }">Status GERK-a za izplačilo v tej sezoni bo {{warrning.placiloStatus}}</p>
        <p :style="{ margin: '25px', textAlign: 'center' }">{{warrning.razlog}}</p>
        <dialog-actions-bar>
           <!--  <button class="k-button" @click='closeDialogCancel'>Prekliči</button> -->
            <button class="k-button" @click='closeDialogConfirm'>Nadaljuj</button>
        </dialog-actions-bar>
    </k-dialog>
    <kendo-buttongroup :enable="enabled" :key="componentKey" :index="getIndex"  @select="onSelect" :selection="'single'" >
    
            <kendo-buttongroup-button>K</kendo-buttongroup-button>
            <kendo-buttongroup-button>EK</kendo-buttongroup-button>
            <kendo-buttongroup-button>PEK</kendo-buttongroup-button>
            <kendo-buttongroup-button>N</kendo-buttongroup-button>
           </kendo-buttongroup>
    </td>
</template>
<script>

import { mapState, mapActions,mapMutations } from 'vuex'
import Vue from 'vue'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';

export default {
      components: {
    'k-dialog': Dialog,
    'dialog-actions-bar': DialogActionsBar
  },
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
       
    },
    data: function () {
        return {
            visibleDialog: false, componentKey: 0,
        };
    },
    computed: {
       ...mapState('gerk', ['warrning']),
       ...mapState('users', ['sezonePisanje']),
        ...mapState('pridelava', ['pridelovalec']) ,  
       enabled(){
        this.forceRerender();
        return !(this.pridelovalec.pisanje==0);
       },
       created(){
     
       },
      renderCell(){
      
        return this.field !== undefined && this.rowType !== 'groupHeader';
      },
     
      getIndex(){
        if(!this.dataItem)
            return 1;

        if(this.dataItem.stanje=="0")
          return 1;
        
        switch(this.dataItem.status){
          case "N":
          return 3;
          break;
         case "E":
          return 1;
          break;
          case "P":
          return 2;
          break;
          
          case "K":
          return 0;
          break;

          default:
          return 3;
          break;
  
          
           
        }
        return 1;
      }
    },
    
    methods: {

      ...mapActions('gerk', ['checkStatus']),
      ...mapMutations('gerk', ['save']),
        onSelect: function(e) {
          var nepk=["K","E","P","N"];
          
           
          this.checkStatus({gerk:this.dataItem,status:nepk[e.indices]});
        
          
        },
        forceRerender() {
          this.componentKey += 1;
        },
        
        closeDialogConfirm() {
          this.warrning.opozorilo = false;
          
        }
       
    }
}
</script>